module.exports = __webpack_public_path__ + "static/media/bid.d2bf0590.png";